export const fullWidthBlock = (container) => {
    const element = container;
    const setWidth = () => {
        let width = document.body.clientWidth;
        let elementWidth = element.offsetWidth;
        element.style.width = `${width}px`;
        element.style.marginLeft = `-${(width - elementWidth) / 2}px`;
    };
    const setDefaultWidth = () => {
        element.style.width = null;
        element.style.marginLeft = null;
    };
    const handleResize = () => {
        setDefaultWidth();
        setWidth();
    };
    setWidth();
    window.addEventListener("resize", handleResize);
    element.addEventListener("changeFile", handleResize);
    element.addEventListener("fileInputGenerated", handleResize);
};
export function initDefaultFWBlocks() {
    const blocks = document.querySelectorAll("[data-fw-container]");
    blocks.forEach((block) => fullWidthBlock(block));
}
